export default "__VITE_ASSET__DXWB8o4J__"